import React from "react";
import {HashLink} from "react-router-hash-link";
import ReactGA from "react-ga4";


const scrollWithOffset = (el) => {
    // const isWindow = typeof window !== 'undefined';
    //
    // if (isWindow && window.innerWidth > 500) {
    const yCoordinate = el.getBoundingClientRect().top + window.scrollY;
    const yOffset = -80;
    window.scrollTo({top: yCoordinate + yOffset, behavior: "smooth"});
    //}
};

const NavLinks = (props) => {

    const handleClick = (trackingLabel) => {
        if (props.onLinkClick) {
            props.onLinkClick();
        }

        //https://stackoverflow.com/questions/49279820/adding-google-analytics-to-react
        ReactGA.send({hitType: "pageview", page: "/" + trackingLabel, title: trackingLabel});
        // ReactGA.event({
        //     category: "MainMenu",
        //     action: "Menu click",
        //     label: trackingLabel
        // });
    }

    return (
        <>
            <HashLink
                className="px-4 font-extrabold text-black hover:text-brand"
                smooth
                to="/#about"
                onClick={() => handleClick("O nas")}
                scroll={(el) => scrollWithOffset(el)}
                title={"O firme M&rivet s.r.o."}
            >
                O nás
            </HashLink>
            <HashLink
                className="px-4 font-extrabold text-black hover:text-brand"
                smooth
                to="/#services"
                onClick={() => handleClick("Služby")}
                scroll={(el) => scrollWithOffset(el)}
                title={"Služby ponúkané spoločnosťou  M&rivet s.r.o."}
            >
                Služby
            </HashLink>
            {/*<HashLink*/}
            {/*    className="px-4 font-extrabold text-black hover:text-brand"*/}
            {/*    smooth*/}
            {/*    to="/#clients"*/}
            {/*    onClick={() => handleClick("Referencie")}*/}
            {/*    scroll={(el) => scrollWithOffset(el)}*/}
            {/*>*/}
            {/*    Referencie*/}
            {/*</HashLink>*/}
            <HashLink
                className="px-4 font-extrabold text-black hover:text-brand"
                smooth
                to="/predaj-naradia"
                title={"M&rivet s.r.o. ponuka predaja náradia"}
            >
                Predaj náradia
            </HashLink>
            <HashLink
                className="px-4 font-extrabold text-black hover:text-brand"
                smooth
                to="/rezanie-vodnym-lucom"
                title={"Rezanie vodným lúčom spoločnosťou M&rivet s.r.o."}
            >
                Rezanie vodným lúčom
            </HashLink>


            <HashLink
                className="text-white bg-brand hover:bg-brand-900 inline-flex items-center justify-center w-auto px-6 py-3 shadow-xl rounded-xl"
                smooth
                to="/#contacts"
                onClick={() => handleClick("Kontakt")}
                scroll={(el) => scrollWithOffset(el)}
            >
                Kontakt
            </HashLink>
        </>
    );
};

export default NavLinks;


